<div class="form_wrapper" *ngIf="this.globalService.externalAnalysisList && this.globalService.externalAnalysisList.length>0">
    <a href="javascript:void(0)" (click)="openForm=!openForm" [ngStyle]="{'width':'169px'}" class="btn btn-dark btn-add"><span>+</span>  New Report</a>
    <br/>
    <ng-container *ngIf="openForm">
        <form [formGroup]="extranlForm">
            <div class="input-row input-row-wide external-change">
                <div class="input-wrap">

                    <div class="type-text">
                        <span class="input-title">Name <em> *</em></span>
                    </div>
                    <div class="dropdown-wrap external-dropdown" [ngClass]="{'disable-input':!globalService.externalAnalysisName}">
                        <app-form-select-box [options]="globalService.externalAnalysisName" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [isDefaultOptionShowHidden]="'false'" [formElementName]="extranlForm" [controlName]="'name_select_name'" (currentSelectionChange)="changeSelection($event)"
                            [currentSelectedValue]="extranlForm['controls']['name']['value']">
                        </app-form-select-box>
                    </div>
                </div>
                <div class="input-wrap">

                    <div class="type-text">
                        <span class="input-title">Type <em> *</em></span>
                    </div>

                    <div class="dropdown-wrap external-dropdown" [ngClass]="{'disable-input':!globalService.externalAnalysisType}">
                        <app-form-select-box [options]="globalService.externalAnalysisType" [isDefaultOptionShowHidden]="'false'" [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [formElementName]="extranlForm" [controlName]="'type_select_name'" (currentSelectionChange)="changeSelection($event)"
                            [currentSelectedValue]="extranlForm['controls']['type']['value']">
                        </app-form-select-box>
                    </div>
                </div>
                <div class="input-wrap">
                    <a href="javascript:void(0)" class="btn btn-dark" (click)="submitForm()">Change</a>
                </div>
            </div>
        </form>
    </ng-container>
</div>
<ng-container *ngIf="globalService.externalAnalysisList && globalService.externalAnalysisList.length>0">
    <iframe width="100%" height="700px" [src]="(frameUrl?frameUrl:globalService.externalAnalysisList[0]['url']) |safe" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</ng-container>
<!-- <iframe src="https://public.tableau.com/profile/sanket.jain2389#!/vizhome/shared/TMPJF8386" title="description"> -->